import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Head from '@/components/base/Head';
import { siteInfo } from '@/mocks/data';

export default function AboutPage() {
  const jsonLdOrg = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '黑料吃瓜网',
    url: '/',
    description: siteInfo.description,
    email: siteInfo.email,
    telephone: siteInfo.phone,
    address: {
      '@type': 'PostalAddress',
      addressLocality: '中国',
    },
    sameAs: [
      siteInfo.socialLinks.weibo,
      siteInfo.socialLinks.douyin,
    ],
  };

  const breadcrumbJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: '/' },
      { '@type': 'ListItem', position: 2, name: '关于我们', item: '/about' },
    ],
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '黑料吃瓜网的内容来源是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们的内容来源于多方渠道，包括网友投稿、网络综合整理、独家追踪报道等。所有内容均经过编辑团队核实后方才发布，确保信息的真实性和时效性。',
        },
      },
      {
        '@type': 'Question',
        name: '黑料吃瓜网如何保证内容的真实性？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们拥有一支专业的编辑团队，对每一条爆料进行多方交叉验证。对于无法完全核实的内容，我们会在文中明确标注信息来源，供读者自行判断。',
        },
      },
      {
        '@type': 'Question',
        name: '如何向黑料吃瓜网投稿爆料？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过网站底部的联系方式发送爆料信息至我们的邮箱，或通过社交媒体私信联系我们。我们承诺保护爆料人的隐私安全。',
        },
      },
      {
        '@type': 'Question',
        name: '黑料吃瓜网的内容更新频率如何？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们实行7×24小时全天候内容更新机制，确保您随时访问都能获取到最新的热点黑料和网红大瓜。重大爆料事件我们会进行实时追踪报道。',
        },
      },
      {
        '@type': 'Question',
        name: '黑料吃瓜网有移动端App吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '目前您可以通过移动端浏览器访问我们的网站，获得优化的手机端浏览体验。App正在开发中，敬请期待。您也可以关注我们的社交媒体账号获取最新动态。',
        },
      },
    ],
  };

  return (
    <>
      <Head
        title="关于我们 - 黑料吃瓜网 | 全网吃瓜第一站"
        description="黑料吃瓜网品牌介绍：全网吃瓜第一站，真相永不迟到。每日更新最新热点黑料、网红大瓜，实行7×24小时实时追踪，覆盖娱乐圈、网红圈、互联网圈等全网爆料。"
        keywords="关于黑料吃瓜网,吃瓜网品牌介绍,黑料吃瓜网联系方式,吃瓜第一站"
        canonicalUrl="/about"
        ogTitle="关于我们 - 黑料吃瓜网 | 全网吃瓜第一站"
        ogDescription="了解黑料吃瓜网的品牌故事与平台实力，全网吃瓜第一站，真相永不迟到。"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdOrg) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <Navbar />

      <main>
        <section className="pt-28 md:pt-36 pb-16 md:pb-24 bg-background-100">
          <div className="max-w-[800px] mx-auto px-4 md:px-8 text-center">
            <span className="text-xs font-medium text-primary-500 uppercase tracking-widest">
              关于我们
            </span>
            <h1 className="mt-4 text-3xl md:text-5xl font-heading text-foreground-950 leading-tight">
              全网吃瓜第一站
              <br />
              真相永不迟到
              <span className="ml-2" role="img" aria-label="奖杯">🏆</span>
            </h1>
            <p className="mt-8 text-base md:text-lg text-foreground-700 leading-relaxed max-w-2xl mx-auto">
              {siteInfo.description}
            </p>
          </div>
        </section>

        <section className="py-16 md:py-24 bg-background-50">
          <div className="max-w-[1280px] mx-auto px-4 md:px-8">
            <div className="text-center mb-12">
              <span className="text-xs font-medium text-secondary-600 uppercase tracking-widest">
                平台实力
              </span>
              <h2 className="mt-3 text-3xl md:text-4xl font-heading text-foreground-950">
                为什么选择黑料吃瓜网
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-background-100 rounded-lg p-8 text-center transition-all duration-300 hover:scale-[1.02]">
                <div className="w-14 h-14 mx-auto bg-primary-100 rounded-lg flex items-center justify-center">
                  <i className="ri-flashlight-line text-2xl text-primary-500"></i>
                </div>
                <h3 className="mt-5 text-xl font-heading text-foreground-900">
                  {siteInfo.stats.dailyPosts}+ 日更爆料
                </h3>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                  每日有超过{siteInfo.stats.dailyPosts}条最新爆料内容更新，从娱乐圈到网红圈，从社会热点到互联网圈，全方位覆盖，让你不错过任何一个大瓜。
                </p>
              </div>
              <div className="bg-background-100 rounded-lg p-8 text-center transition-all duration-300 hover:scale-[1.02]">
                <div className="w-14 h-14 mx-auto bg-accent-100 rounded-lg flex items-center justify-center">
                  <i className="ri-radar-line text-2xl text-accent-500"></i>
                </div>
                <h3 className="mt-5 text-xl font-heading text-foreground-900">
                  {siteInfo.stats.coverage} 全网覆盖
                </h3>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                  我们的信息网络覆盖全网主流社交平台、论坛、短视频平台，确保第一时间捕捉每一条有价值的爆料信息，信息覆盖率高达{siteInfo.stats.coverage}。
                </p>
              </div>
              <div className="bg-background-100 rounded-lg p-8 text-center transition-all duration-300 hover:scale-[1.02]">
                <div className="w-14 h-14 mx-auto bg-secondary-100 rounded-lg flex items-center justify-center">
                  <i className="ri-time-line text-2xl text-secondary-500"></i>
                </div>
                <h3 className="mt-5 text-xl font-heading text-foreground-900">
                  {siteInfo.stats.updateFrequency} 实时追踪
                </h3>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                  我们实行{siteInfo.stats.updateFrequency}的全天候内容更新机制。无论白天还是深夜，一旦有新的大瓜出现，我们的编辑团队会在第一时间为您呈现。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 md:py-24 bg-background-100">
          <div className="max-w-[1280px] mx-auto px-4 md:px-8">
            <div className="text-center mb-12">
              <span className="text-xs font-medium text-secondary-600 uppercase tracking-widest">
                品牌口碑
              </span>
              <h2 className="mt-3 text-3xl md:text-4xl font-heading text-foreground-950">
                用户与媒体评价
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-background-50 rounded-lg p-6 border border-background-200/60">
                <div className="flex items-center gap-1 text-accent-500 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  "黑料吃瓜网是我每天必刷的网站，更新速度快，内容质量高。每次有大瓜都是在这里第一时间看到，比微博热搜还快！"
                </p>
                <div className="flex items-center gap-3 mt-5 pt-4 border-t border-background-200/60">
                  <span className="w-8 h-8 bg-primary-100 rounded-full flex items-center justify-center text-sm font-bold text-primary-500">
                    小
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-foreground-800">小明同学</p>
                    <p className="text-xs text-foreground-500">忠实用户 · 使用3年</p>
                  </div>
                </div>
              </div>
              <div className="bg-background-50 rounded-lg p-6 border border-background-200/60">
                <div className="flex items-center gap-1 text-accent-500 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  "作为自媒体人，我非常认可黑料吃瓜网的专业度。他们的信息把关很严格，不会为了流量随便发未经证实的谣言，这在八卦类网站中非常难得。"
                </p>
                <div className="flex items-center gap-3 mt-5 pt-4 border-t border-background-200/60">
                  <span className="w-8 h-8 bg-accent-100 rounded-full flex items-center justify-center text-sm font-bold text-accent-500">
                    媒
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-foreground-800">传媒观察</p>
                    <p className="text-xs text-foreground-500">行业媒体 · 合作2年</p>
                  </div>
                </div>
              </div>
              <div className="bg-background-50 rounded-lg p-6 border border-background-200/60">
                <div className="flex items-center gap-1 text-accent-500 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  "作为一个吃瓜爱好者，黑料吃瓜网的分类做得特别好，想看什么类型的八卦都能快速找到。页面也清爽干净，没有乱七八糟的广告干扰。"
                </p>
                <div className="flex items-center gap-3 mt-5 pt-4 border-t border-background-200/60">
                  <span className="w-8 h-8 bg-secondary-100 rounded-full flex items-center justify-center text-sm font-bold text-secondary-500">
                    瓜
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-foreground-800">吃瓜少女</p>
                    <p className="text-xs text-foreground-500">资深用户 · 使用1年</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 md:py-24 bg-background-50">
          <div className="max-w-[900px] mx-auto px-4 md:px-8">
            <div className="text-center mb-12">
              <span className="text-xs font-medium text-secondary-600 uppercase tracking-widest">
                联系我们
              </span>
              <h2 className="mt-3 text-3xl md:text-4xl font-heading text-foreground-950">
                商务合作 & 投稿爆料
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-background-100 rounded-lg p-8">
                <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center mb-5">
                  <i className="ri-mail-line text-xl text-primary-500"></i>
                </div>
                <h3 className="text-lg font-heading text-foreground-900">商务合作</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  如果您有广告投放、品牌合作、内容授权等商务需求，欢迎通过以下方式联系我们。我们会在24小时内回复您的咨询。
                </p>
                <div className="mt-5 space-y-3">
                  <div className="flex items-center gap-3 text-sm text-foreground-700">
                    <i className="ri-mail-line text-primary-500"></i>
                    <span>admin@chigua.example.com</span>
                  </div>
                  <div className="flex items-center gap-3 text-sm text-foreground-700">
                    <i className="ri-phone-line text-primary-500"></i>
                    <span>{siteInfo.phone}</span>
                  </div>
                </div>
              </div>
              <div className="bg-background-100 rounded-lg p-8">
                <div className="w-12 h-12 bg-accent-100 rounded-lg flex items-center justify-center mb-5">
                  <i className="ri-spy-line text-xl text-accent-500"></i>
                </div>
                <h3 className="text-lg font-heading text-foreground-900">投稿爆料</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  如果您有独家爆料线索，欢迎向我们投稿。我们承诺严格保护爆料人隐私，并对重大独家爆料提供丰厚报酬。期待您的发声！
                </p>
                <div className="mt-5 space-y-3">
                  <div className="flex items-center gap-3 text-sm text-foreground-700">
                    <i className="ri-mail-line text-accent-500"></i>
                    <span>tips@chigua.example.com</span>
                  </div>
                  <div className="flex items-center gap-3 text-sm text-foreground-700">
                    <i className="ri-shield-check-line text-accent-500"></i>
                    <span>隐私安全保障，欢迎匿名投稿</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-10 bg-background-100 rounded-lg p-8 text-center">
              <h3 className="text-lg font-heading text-foreground-900">关注我们的社交媒体</h3>
              <p className="mt-2 text-sm text-foreground-600">
                第一时间获取最新爆料，不错过每一个精彩大瓜
              </p>
              <div className="flex items-center justify-center gap-4 mt-6">
                <a href={siteInfo.socialLinks.weibo} className="w-12 h-12 rounded-full bg-background-50 border border-background-200/60 flex items-center justify-center text-foreground-600 hover:text-primary-500 hover:border-primary-500 transition-colors" aria-label="微博" rel="nofollow">
                  <i className="ri-weibo-line text-xl"></i>
                </a>
                <a href={siteInfo.socialLinks.wechat} className="w-12 h-12 rounded-full bg-background-50 border border-background-200/60 flex items-center justify-center text-foreground-600 hover:text-primary-500 hover:border-primary-500 transition-colors" aria-label="微信" rel="nofollow">
                  <i className="ri-wechat-line text-xl"></i>
                </a>
                <a href={siteInfo.socialLinks.douyin} className="w-12 h-12 rounded-full bg-background-50 border border-background-200/60 flex items-center justify-center text-foreground-600 hover:text-primary-500 hover:border-primary-500 transition-colors" aria-label="抖音" rel="nofollow">
                  <i className="ri-tiktok-line text-xl"></i>
                </a>
                <a href={siteInfo.socialLinks.xiaohongshu} className="w-12 h-12 rounded-full bg-background-50 border border-background-200/60 flex items-center justify-center text-foreground-600 hover:text-primary-500 hover:border-primary-500 transition-colors" aria-label="小红书" rel="nofollow">
                  <i className="ri-booklet-line text-xl"></i>
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}